import { render, staticRenderFns } from "./CheckPhoneNumber.vue?vue&type=template&id=08900496"
import script from "./CheckPhoneNumber.vue?vue&type=script&lang=js"
export * from "./CheckPhoneNumber.vue?vue&type=script&lang=js"
import style0 from "./CheckPhoneNumber.vue?vue&type=style&index=0&id=08900496&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports